/**
 * Created by iqpir on 5/28/2017.
 */
import { ElementRef } from "@angular/core";

export class MenuItem {
    public Name : string;
    public Path : string;
    public Icon : string;
    public IconClass : string;
    public Children : Array<MenuItem>;
    public Collapsed: boolean;
    public Disabled: boolean;
    public ShowCaret: boolean = true;
    public Exact: boolean = true;
    public Element: ElementRef;
    
    public ShowButton: boolean;
    public ButtonText: string;
    public ButtonHandler: any;

    constructor(obj: Partial<MenuItem>) {
        Object.assign(this, obj);
        this.Collapsed = this.Collapsed == null ? true : this.Collapsed;
        this.Disabled = this.Disabled || false;
        this.Exact = this.Exact || true;
    }
}


// WEBPACK FOOTER //
// ./app/objects/components/menuItem.ts